/**
 * @generated SignedSource<<3c9472411adcfa17f8f4333348b44bfb>>
 * @relayHash eb7ad2588ded6f5778b3afbee07ab479
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6abe3e3c13793441b7438b6bf4af79feab5429c91c6902c0f785da6f786c4054

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateScreenQuery } from './FirstCreateScreenQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateScreenQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6abe3e3c13793441b7438b6bf4af79feab5429c91c6902c0f785da6f786c4054",
    "metadata": {},
    "name": "FirstCreateScreenQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
